<template>
  <md-card
    class="dynamic-card"
    :class="{ 'transparent-card': transparentCard }"
  >
    <md-card-header :class="{ 'no-spacement-header': transparentCard }">
      <md-card-header-text>
        <h2
          v-if="titleAction"
          class="title-action"
          @click="titleAction"
        >
          {{ title }}
        </h2>
        <h2 v-else>
          {{ title }}
        </h2>
        <h3 :class="{ subtitleRegular: capitalizeSubtitle }">
          {{ subtitleRegular }}
          <span
            v-if="subtitleHighlight"
            class="bold"
          >
            {{ subtitleHighlight }}
          </span>
          <md-tooltip v-if="subtitleRegular">
            {{ subtitleRegular }}
            <span v-if="subtitleHighlight">{{ subtitleHighlight }}</span>
          </md-tooltip>
        </h3>
      </md-card-header-text>
    </md-card-header>
    <md-card-content v-if="slotEnabled">
      <slot />
    </md-card-content>
    <md-card-actions
      v-if="buttons"
      :class="{ barchartcard: title === 'Rastreabilidade - produção' }"
    >
      <template v-if="title === 'Rastreabilidade - produção'">
        <div>
          <div class="download-btn">
            <button
              v-if="buttons[0].visible"
              :id="buttons[0].id"
              :key="'button' + buttons[0].action"
              class="btn-small button"
              :class="[
                buttons[0].style + buttonWidth(buttons[0].halfWidth),
                { 'btn-disabled': buttons[0].disabled },
              ]"
              :disabled="buttons[0].disabled"
              @click="go(buttons[0].action)"
            >
              {{ buttons[0].text }}
            </button>
          </div>
          <div class="btn-row">
            <button
              v-if="buttons[1].visible"
              :id="buttons[1].id"
              :key="'button' + buttons[1].action"
              class="btn-small button"
              :class="buttons[1].style + buttonWidth(buttons[1].halfWidth)"
              @click="go(buttons[1].action)"
            >
              <div>
                <svg-loader
                  v-if="buttons[1].icon"
                  :src="buttons[1].icon"
                  css="gray"
                />
                {{ buttons[1].text }}
              </div>
            </button>
            <button
              v-if="buttons[2].visible"
              :id="buttons[2].id"
              :key="'button' + buttons[2].action"
              class="btn-small button"
              :class="buttons[2].style + buttonWidth(buttons[2].halfWidth)"
              @click="go(buttons[2].action)"
            >
              <div>
                <svg-loader
                  v-if="buttons[2].icon"
                  :src="buttons[2].icon"
                  css="gray"
                />
                {{ buttons[2].text }}
              </div>
            </button>
          </div>
        </div>
      </template>
      <template v-if="title !== 'Rastreabilidade - produção'">
        <template v-for="button in buttons">
          <button
            v-if="button.visible"
            :id="button.id"
            :key="'button' + button.action"
            class="btn-small button"
            :class="button.style + buttonWidth(button.halfWidth)"
            @click="go(button.action)"
          >
            {{ button.text }}
          </button>
        </template>
      </template>
    </md-card-actions>
  </md-card>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: String,
    titleAction: Function,
    subtitleRegular: String,
    capitalizeSubtitle: {
      type: Boolean,
      default: false,
    },
    transparentCard: {
      type: Boolean,
      default: false,
    },
    subtitleHighlight: String,
    buttons: Array,
    settingsButtonEnabled: {
      type: Boolean,
      default: true,
    },
    slotEnabled: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    go(action) {
      this.$emit('click', action)
    },
    buttonWidth: function (width) {
      return !width ? ' button--full' : ' button--half'
    },
  },
}
</script>

<style lang="scss">
.md-card-actions.barchartcard {
  padding: 0 !important;
  margin: 0 !important;
}
.download-btn {
  padding: 0 15px;
}
.md-card-actions.barchartcard button {
  margin: 0;
}
.barchartcard .btn-row {
  border-top: 1px solid #ddd;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    margin-top: 20px;
  }
}

.md-card-actions.barchartcard > div {
  width: 100%;
}
.barchartcard .btn-row button:nth-of-type(2n) {
  border-left: 1px solid #ddd;
  margin: 0 !important;
}
.barchartcard .btn-row button {
  width: 100%;
  height: 42px;
  display: flex;
  border-radius: 0;
  margin: 0 !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
}
.barchartcard .btn-row div i {
  margin-right: 5px;

  @media (max-width: 1200px) {
    display: none;
  }
}
.dynamic-card {
  border-radius: 3px;
  box-shadow: none;
  overflow: hidden;
  z-index: auto !important;
  min-height: 130px;
  flex: 1;
  height: 100%;

  .md-card {
    &-header,
    &-content {
      padding-bottom: 0 !important;
    }

    &-actions {
      margin-top: auto;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: inherit;
      padding: 6px 16px;
      margin-bottom: 6px;

      .button {
        padding: 15px 0;
        letter-spacing: 0.8px;
        font-weight: 580;
        text-transform: uppercase;
        margin-bottom: 2px;
        line-height: 1.2;
        flex-direction: column;

        // For IE 11
        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
          flex-direction: row;
        }

        &--half {
          width: 50%;
          min-width: 50%;
          margin: 5px 0px;
          padding: 0;
        }
        &--full {
          width: 100%;

          @media (max-width: 1200px) {
            font-size: 10px;
          }
        }
      }
    }
  }

  h2,
  h3 {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 400;
    line-height: 26px;
  }

  h2 {
    font-size: 17px;
    height: 17px;
    color: #4a4a4a;

    @media (max-width: 1200px) {
      font-size: 16px;
      height: 16px;
    }
  }

  h3 {
    font-size: 12px;
    height: 14px;
    color: #7a7a7a;
    margin-top: 1px;
    :first-letter {
      text-transform: capitalize;
    }
  }

  .title-action {
    cursor: pointer;
    display: table;
  }

  .bold {
    font-weight: bold;
  }

  .subtitleRegular {
    text-transform: lowercase;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 137px;
    height: auto;

    @media (max-width: 1200px) {
      max-width: 100%;
    }

    &::first-letter {
      text-transform: uppercase;
    }
  }

  &.transparent-card {
    background-color: transparent !important;
  }

  .no-spacement-header {
    padding-top: 0px !important;
  }

  .md-card-header-text {
    @media (max-width: 1200px) {
      width: 100%;
    }
  }

  .btn-disabled,
  button:disabled {
    cursor: not-allowed !important;
    opacity: 0.6;
    pointer-events: none;
  }
}
</style>
